import { csvw_url } from "../../components/config";
let a = {
  title: "",
  titleEn: "",
  subtitle: "",
  subtitleEn: "",
  dec: "",
  decEn: "",
  img: "",
  imgMobile: "",
  list: [],
};
let b = {
  title: "",
  titleEn: "",
  dec: "",
  decEn: "",
};
export default {
  title: "优质教育",
  titleEn: "Quality Education",
  btn: [
    {
      title: "“繁星计划”希望小学公益行动",
      titleEn: "\"Starry Program\" Hope Primary School Assistance Action",
      subtitle: "",
      subtitleEn: "",
      dec:
        '早在1995年，上汽大众就关注到青少年教育在欠发达地区发展中的重要性，开始在新疆地区援建希望小学。自2012年起，公司连续5年向新疆地区捐助教育资金，并为当地学校配备电脑室、美术室和体育器材。<br>2015年，上汽大众联合中国青少年发展基金会等专业公益组织，发起“繁星计划”，为乡村学校改善教学楼建设与教学环境、提供教学设备与教学资源等方式。截至目前，上汽大众“繁星计划”累计捐赠超过1,600万元，在湖南、河南、广西、湖北、新疆、贵州、陕西、云南各省援建了11所希望学校，每年有超过千名青少年受益。',
      decEn:
        "As early as 1995, SAIC VOLKSWAGEN began to build Hope Primary Schools in the Xinjiang Uighur Autonomous Region with concern for the importance of youth education for development of less developed regions. Since 2012, the Company has donated educational funds to Xinjiang for five consecutive years and equipped local schools with computer rooms, art rooms and sports equipment.<br>In 2015, SAIC VOLKSWAGEN joined hands with the China Youth Development Foundation and other professional public welfare organizations to launch the “Starry Program” which is aimed at improving the construction of school buildings and teaching environment. Under the project, SAIC VOLKSWAGEN provides teaching equipment and teaching resources to rural schools. To date, SAIC VOLKSWAGEN has donated more than RMB 16 million to build 11 Hope Schools in Hunan, Henan, Hubei, Guizhou, Shaanxi and Yunnan provinces and Guangxi Zhuang Autonomous Region and Xinjiang, benefiting more than 1,000 children and teenagers each year.",
      img: require("../../assets/csr/imgs/Qtu1@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MQtu1@2x.png"),
      img2: require("../../assets/csr/imgs/Qcon1@2x.png"),
      imgMobile2: require("../../assets/csr/imgsMobile/MQcon1@2x.png"),
      list: [],
    },
    {
      title: "教育公平发展",
      titleEn: "Equal Access to Education",
      subtitle: "",
      subtitleEn: "",
      dec:
        "在乡村振兴、实现共同富裕的道路上，教育发挥着基础性、先导性作用。作为持续关注中国乡村教育、助力教育公平的企业，上汽大众敏锐地意识到，近年来乡村教育在不断发展变化，而公益项目也需要与时俱进，才能满足新时期乡村师生对于教育的需求。",
      decEn:
        "Education plays a fundamental and pioneering role in the course of rural revitalization and achieving common prosperity. As a corporate entity that has been continuously focusing on education in the rural areas of China and contributing to equal educational opportunities, SAIC VOLKSWAGEN is keenly aware that rural education has been constantly evolving in recent years, and that public welfare programs need to keep pace with the times in order to meet the educational needs of rural teachers and students in the new era.",
      img: require("../../assets/csr/imgs/Qtu2@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MQtu2@2x.png"),
      img2: "",
      imgMobile2: "",
      list: [],
    },
  ],
};
